var path = 'areas/projects/views/feature_editor.html';
var html = "<div> <uib-accordion class=\"feature-list accordion arrows\"></uib-accordion> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/views/feature_editor.html
// module id = 931
// module chunks = 1